(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pq-popup-bienvenue"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ABONNEMENT = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';
    const SUIVI = 'https://a.klaviyo.com/api';
    const ADRESSE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    /** Encode en base64 en passant par UTF-8 : btoa seul casse sur les accents. */
    const enBase64 = (objet) => {
      const octets = new TextEncoder().encode(JSON.stringify(objet));
      let binaire = '';
      octets.forEach((o) => { binaire += String.fromCharCode(o); });
      return btoa(binaire);
    };

    const appeler = (route, donnees) =>
      fetch(`${SUIVI}/${route}?data=${encodeURIComponent(enBase64(donnees))}`).catch(() => {});

    /* Requête sans en-tête ajouté : pas de contrôle CORS préalable, elle passe
       depuis le navigateur. */
    const abonner = (reglages, champs) => {
      const corps = new URLSearchParams();
      const supplementaires = ['$consent', '$source'];
      corps.set('g', reglages.liste);
      corps.set('email', champs.email);
      corps.set('$consent', '["email"]');
      corps.set('$source', reglages.source);
      if (champs.prenom) {
        corps.set('$first_name', champs.prenom);
        supplementaires.push('$first_name');
      }
      corps.set('$fields', supplementaires.join(','));
      return fetch(ABONNEMENT, { method: 'POST', body: corps })
        .then((reponse) => reponse.json())
        .then((resultat) => {
          if (!resultat || resultat.success !== true) throw new Error('abonnement refusé');
        });
    };

    const completerFiche = (reglages, champs) => {
      const proprietes = { $email: champs.email };
      if (champs.prenom) proprietes.$first_name = champs.prenom;
      if (champs.ouverture) proprietes[reglages.proprieteOuverture] = champs.ouverture;
      appeler('identify', { token: reglages.societe, properties: proprietes });
      appeler('track', {
        token: reglages.societe,
        event: 'Formulaire envoyé',
        customer_properties: { $email: champs.email },
        properties: { formulaire: reglages.formulaire, source: 'shopify-theme' },
      });
    };

    const lireChamps = (form) => {
      const choix = form.querySelector('input[name="ouverture"]:checked');
      return {
        email: form.elements.email.value.trim(),
        prenom: form.elements.prenom.value.trim(),
        ouverture: choix ? choix.value : '',
        leurre: form.elements.site.value,
      };
    };

    const silencieux = (popup) => {
      try {
        const jusqua = window.localStorage.getItem(popup.dataset.repere);
        return Boolean(jusqua) && Date.now() < Number(jusqua);
      } catch (erreur) {
        return false;
      }
    };

    const taire = (popup) => {
      const jours = Number(popup.dataset.silence) || 0;
      try {
        window.localStorage.setItem(popup.dataset.repere, String(Date.now() + jours * 86400000));
      } catch (erreur) {
        // Stockage indisponible : le popup reviendra au prochain chargement.
      }
    };

    const montrerEtape = (popup, nom) => {
      popup.querySelectorAll('[data-pq-etape]').forEach((etape) => {
        etape.hidden = etape.dataset.pqEtape !== nom;
      });
      const cible = popup.querySelector(`[data-pq-etape="${nom}"] input:not([tabindex="-1"]), [data-pq-etape="${nom}"] button`);
      if (cible) cible.focus();
    };

    const fermer = (popup) => {
      popup.hidden = true;
      if (!window.Shopify || !window.Shopify.designMode) taire(popup);
    };

    const signalerErreur = (form, texte) => {
      const message = form.querySelector('[data-pq-message]');
      message.textContent = texte;
      message.hidden = false;
    };

    const envoyer = (popup, form) => {
      const champs = lireChamps(form);
      const reglages = popup.dataset;
      if (champs.leurre) return montrerEtape(popup, 'merci');
      if (!ADRESSE.test(champs.email) || !form.checkValidity()) {
        return signalerErreur(form, reglages.messageAdresse);
      }
      const bouton = form.querySelector('[type="submit"]');
      bouton.disabled = true;
      return abonner(reglages, champs)
        .then(() => {
          completerFiche(reglages, champs);
          taire(popup);
          montrerEtape(popup, 'merci');
        })
        .catch(() => signalerErreur(form, reglages.messageErreur))
        .finally(() => { bouton.disabled = false; });
    };

    const brancher = (popup) => {
      const form = popup.querySelector('form');
      popup.querySelectorAll('[data-pq-fermer]').forEach((cible) => {
        cible.addEventListener('click', () => fermer(popup));
      });
      popup.querySelector('[data-pq-suivant]').addEventListener('click', () => montrerEtape(popup, 'inscription'));
      form.addEventListener('submit', (evenement) => {
        evenement.preventDefault();
        envoyer(popup, form);
      });
      document.addEventListener('keydown', (evenement) => {
        if (evenement.key === 'Escape' && !popup.hidden) fermer(popup);
      });
    };

    const ouvrir = (popup) => {
      montrerEtape(popup, 'offre');
      popup.hidden = false;
    };

    const armer = (racine) => {
      racine.querySelectorAll('[data-pq-bienvenue]').forEach((popup) => {
        if (popup.dataset.pqArme === '1') return;
        popup.dataset.pqArme = '1';
        brancher(popup);
        const editeur = Boolean(window.Shopify && window.Shopify.designMode);
        if (editeur) return ouvrir(popup);
        if (silencieux(popup)) return undefined;
        return window.setTimeout(() => ouvrir(popup), (Number(popup.dataset.delai) || 0) * 1000);
      });
    };

    document.addEventListener('DOMContentLoaded', () => armer(document));
    document.addEventListener('shopify:section:load', (evenement) => armer(evenement.target));
    if (document.readyState !== 'loading') armer(document);
  })();

  } catch(e) { console.error(e); }
})();
})();
